export type StorageParser<T> = (value: unknown) => T | null;

const readStorageJson = <T>(
  storage: Storage,
  key: string,
  parser: StorageParser<T>,
) => {
  try {
    const raw = storage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);

    return parser(parsed);
  } catch {
    return null;
  }
};

const writeStorageJson = (storage: Storage, key: string, value: unknown) => {
  try {
    storage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
};

export const readSessionStorageJson = <T>(
  key: string,
  parser: StorageParser<T>,
) => {
  if (typeof window === 'undefined') return null;

  return readStorageJson(window.sessionStorage, key, parser);
};

export const writeSessionStorageJson = (key: string, value: unknown) => {
  if (typeof window === 'undefined') return false;

  return writeStorageJson(window.sessionStorage, key, value);
};
